(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusAssessControllers')
        .controller('RecomUpdateStatusAssessByActionPlanController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'topBarService', 'bUnit', 'govProcess', 'assessmentsByActionPlan', 'fiscalYearQuarterKeys'];

    function Controller($scope, $state, $stateParams, topBarService, bUnit, govProcess, assessmentsByActionPlan, fiscalYearQuarterKeys) {

        if (redirectToCriterias(assessmentsByActionPlan)) {
            $state.go('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriterias', { 
                ActionPlanID: $stateParams.ActionPlanID
            }, {
                reload: true
            });
        }

        var title = bUnit.TitleEN + ' Action Plans | ' + govProcess.ShortName + ' Progress Tracking';
        topBarService.setTitleAndIcon(title, 'fa fa-road');

        $scope.govProcess = govProcess;

        $scope.ctrlCtxt = {};
        $scope.ctrlCtxt.fiscalYearQuarterKeys = fiscalYearQuarterKeys;

        $scope.actionPlanAssessment = assessmentsByActionPlan.ActionPlanAssessment;
        $scope.actionPlan           = assessmentsByActionPlan.ActionPlan;
        $scope.actionPlanStatusList = assessmentsByActionPlan.ActionPlanStatusList;
        $scope.aPlanAssessmentSummary = assessmentsByActionPlan.ActionPlanAssessmentSummary;

        $scope.canEdit = false;
        if ($scope.actionPlan) {
            $scope.canEdit = $scope.actionPlan.IsOwner || $scope.actionPlan.IsOwnerDelegate;
        }

        function redirectToCriterias(assessmentsByActionPlan) {
            if (_.isUndefined(assessmentsByActionPlan.ActionPlanAssessment)) return false;

            return !assessmentsByActionPlan.ActionPlanAssessment.AreAllCriteriasAssessed;
        }
    }
})();